import { render, staticRenderFns } from "./FieldConfig.vue?vue&type=template&id=fdca826c&"
import script from "./FieldConfig.vue?vue&type=script&lang=js&"
export * from "./FieldConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports